import { IAPIRoutes } from "../../../../config";

export const SupportRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { getAuthenticationToken } = AuthService;
  const { POST } = APIProvider;

  const addReportAProblem: IAddReportAProblemAPI = async ({
    clinic_id,
    ...payload
  }) => {
    return POST(
      APIRoutes.apiReportAProblem.replace("{clinic_id}", clinic_id),
      { ...payload },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const submitFeedback: ISubmitFeedback = async (payload: {
    name: string;
    message: string;
  }) => {
    return POST(APIRoutes.apiSubmitFeedback, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });
  };

  const submitRatingAPI: ISubmitRatingAPI = async ({ ...payload }) => {
    return POST(
      APIRoutes.apiSubmitRating,
      { ...payload },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  return {
    addReportAProblem,
    submitFeedback,
    submitRatingAPI,
  };
};
